import { render, staticRenderFns } from "./CsvUploader.vue?vue&type=template&id=01b8c7d3&scoped=true&"
import script from "./CsvUploader.vue?vue&type=script&lang=js&"
export * from "./CsvUploader.vue?vue&type=script&lang=js&"
import style0 from "./CsvUploader.vue?vue&type=style&index=0&id=01b8c7d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8c7d3",
  null
  
)

export default component.exports